var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.19844C0 0.75661 0.358172 0.398438 0.8 0.398438H15.2C15.6418 0.398438 16 0.75661 16 1.19844C16 1.64027 15.6418 1.99844 15.2 1.99844H0.8C0.358172 1.99844 0 1.64027 0 1.19844ZM2.4 4.39844C2.4 3.95661 2.75817 3.59844 3.2 3.59844H12.8C13.2418 3.59844 13.6 3.95661 13.6 4.39844C13.6 4.84027 13.2418 5.19844 12.8 5.19844H3.2C2.75817 5.19844 2.4 4.84027 2.4 4.39844ZM0 7.59844C0 7.15661 0.358172 6.79844 0.8 6.79844H15.2C15.6418 6.79844 16 7.15661 16 7.59844C16 8.04027 15.6418 8.39844 15.2 8.39844H0.8C0.358172 8.39844 0 8.04027 0 7.59844ZM2.4 10.7984C2.4 10.3566 2.75817 9.99844 3.2 9.99844H12.8C13.2418 9.99844 13.6 10.3566 13.6 10.7984C13.6 11.2403 13.2418 11.5984 12.8 11.5984H3.2C2.75817 11.5984 2.4 11.2403 2.4 10.7984Z",
    fill: "#282830"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlign);
export default __webpack_public_path__ + "static/media/Align.fa6012b5.svg";
export { ForwardRef as ReactComponent };